// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MessagesAsideItem_item__JXIPU {
  display: flex;
  align-items: center;
  border: none;
  border-bottom: 1px solid var(--gray-200);
  background: none;
  text-align: left;
  width: 100%;
  padding: 8px 16px 8px 8px;
  transition: var(--transition);
}
@media (hover: hover) {
  .MessagesAsideItem_item__JXIPU:not(.MessagesAsideItem_item--is-active__20UZP):hover {
    background-color: var(--white-550);
  }
}
.MessagesAsideItem_item--is-active__20UZP {
  background-color: var(--accent-color);
}
.MessagesAsideItem_item--is-active__20UZP .MessagesAsideItem_txt__n9h6G,
.MessagesAsideItem_item--is-active__20UZP .MessagesAsideItem_title__4STYz,
.MessagesAsideItem_item--is-active__20UZP .MessagesAsideItem_time__hEzn7,
.MessagesAsideItem_item--is-active__20UZP .MessagesAsideItem_txtClip__cho1S {
  color: var(--white);
}
@media (max-width: 1200px) {
  .MessagesAsideItem_item--is-active__20UZP .MessagesAsideItem_txt__n9h6G,
  .MessagesAsideItem_item--is-active__20UZP .MessagesAsideItem_title__4STYz,
  .MessagesAsideItem_item--is-active__20UZP .MessagesAsideItem_time__hEzn7,
  .MessagesAsideItem_item--is-active__20UZP .MessagesAsideItem_txtClip__cho1S {
    color: #7A808B;
  }
}
.MessagesAsideItem_item--is-active__20UZP .MessagesAsideItem_avatar--is-empty__3h7yU {
  border-color: var(--accent-text-color);
}
.MessagesAsideItem_item__JXIPU:last-child {
  border: none;
}
@media (max-width: 1200px) {
  .MessagesAsideItem_item__JXIPU {
    background: #FFFFFF;
    padding: 8px;
    border-radius: 12px;
    box-shadow: 0px 5px 9px 0px rgba(0, 0, 0, 0.0509803922);
    border: none;
    position: relative;
  }
  .MessagesAsideItem_item__JXIPU .MessagesAsideItem_title__4STYz {
    color: var(--text-color);
    font-size: var(--fz-lg);
    line-height: var(--lh-lg);
  }
  .MessagesAsideItem_item__JXIPU .MessagesAsideItem_txt__n9h6G,
  .MessagesAsideItem_item__JXIPU .MessagesAsideItem_time__hEzn7 {
    color: #54575C;
    font-size: var(--fz-sm);
  }
  .MessagesAsideItem_item__JXIPU .MessagesAsideItem_imgWrap__3Vkjf {
    position: initial;
  }
}

.MessagesAsideItem_ellipsis-container__OjhLz {
  display: flex;
  gap: 4px;
  overflow: hidden;
}
.MessagesAsideItem_ellipsis-container__OjhLz .shortened-text {
  max-height: 13px;
  width: calc(100% - 20px);
}
.MessagesAsideItem_ellipsis-container__OjhLz span {
  width: max-content;
}

.MessagesAsideItem_imgWrap__3Vkjf {
  position: relative;
  margin-right: 8px;
}

.MessagesAsideItem_avatar--is-empty__3h7yU {
  border: 1px solid transparent;
  transition: var(--transition);
}

.MessagesAsideItem_count__RGvXg {
  position: absolute;
  top: -4px;
  right: -4px;
}

.MessagesAsideItem_content__l4Ky0 {
  width: calc(100% - 48px);
}

.MessagesAsideItem_title__4STYz,
.MessagesAsideItem_txt__n9h6G,
.MessagesAsideItem_time__hEzn7 {
  transition: var(--transition);
}

.MessagesAsideItem_title__4STYz {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 1px;
}

.MessagesAsideItem_name__iwUi9,
.MessagesAsideItem_txt__n9h6G {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.MessagesAsideItem_time__hEzn7 {
  font-size: var(--fz-xs);
  line-height: var(--lh-xs);
  color: #7A808B;
  margin-left: 20px;
}

.MessagesAsideItem_txt__n9h6G {
  color: #7A808B;
  font-size: 10px;
  line-height: 12px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  width: max-content;
}

.MessagesAsideItem_txtImg__hCO8C {
  max-height: 12px;
}

.MessagesAsideItem_txtClip__cho1S {
  display: flex;
  align-items: center;
  color: #7A808B;
  font-size: 10px;
  line-height: 12px;
}
.MessagesAsideItem_txtClip__cho1S svg {
  flex-shrink: 0;
  margin-right: 4px;
}
.MessagesAsideItem_txtClip__cho1S span {
  overflow: hidden;
  text-overflow: ellipsis;
}`, "",{"version":3,"sources":["webpack://./src/components/Modals/MessagesModal/MessagesAsideItem.module.scss"],"names":[],"mappings":"AAqBA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,wCAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,6BAAA;AApBF;AAuBI;EACE;IACE,kCAAA;EArBN;AACF;AAyBE;EAvCA,qCAAA;AAiBF;AAfE;;;;EAIE,mBAAA;AAiBJ;AAfI;EANF;;;;IAOI,cAAA;EAqBJ;AACF;AAjBI;EACE,sCAAA;AAmBN;AASE;EACE,YAAA;AAPJ;AAUE;EA3BF;IA4BI,mBAAA;IACA,YAAA;IACA,mBAAA;IACA,uDAAA;IACA,YAAA;IACA,kBAAA;EAPF;EASE;IACE,wBAAA;IACA,uBAAA;IACA,yBAAA;EAPJ;EAUE;;IAEE,cAAA;IACA,uBAAA;EARJ;EAWE;IACE,iBAAA;EATJ;AACF;;AAaA;EACE,aAAA;EACA,QAAA;EACA,gBAAA;AAVF;AAYI;EACE,gBAAA;EACA,wBAAA;AAVN;AAcE;EACE,kBAAA;AAZJ;;AAgBA;EACE,kBAAA;EACA,iBAAA;AAbF;;AAiBE;EACE,6BAAA;EACA,6BAAA;AAdJ;;AAkBA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AAfF;;AAkBA;EACE,wBAAA;AAfF;;AAkBA;;;EAGE,6BAAA;AAfF;;AAkBA;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,kBAAA;AAfF;;AAkBA;;EAEE,gBAAA;EACA,uBAAA;EACA,mBAAA;AAfF;;AAkBA;EACE,uBAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;AAfF;;AAkBA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;AAfF;;AAkBA;EACE,gBAAA;AAfF;;AAkBA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAfF;AAiBE;EACE,cAAA;EACA,iBAAA;AAfJ;AAkBE;EACE,gBAAA;EACA,uBAAA;AAhBJ","sourcesContent":["@mixin active {\r\n  background-color: var(--accent-color);\r\n\r\n  .txt,\r\n  .title,\r\n  .time,\r\n  .txtClip {\r\n    color: var(--white);\r\n\r\n    @media (max-width: 1200px) {\r\n      color: #7A808B;\r\n    }\r\n  }\r\n\r\n  .avatar {\r\n    &--is-empty {\r\n      border-color: var(--accent-text-color);\r\n    }\r\n  }\r\n}\r\n\r\n.item {\r\n  display: flex;\r\n  align-items: center;\r\n  border: none;\r\n  border-bottom: 1px solid var(--gray-200);\r\n  background: none;\r\n  text-align: left;\r\n  width: 100%;\r\n  padding: 8px 16px 8px 8px;\r\n  transition: var(--transition);\r\n\r\n  &:not(.item--is-active) {\r\n    @media (hover: hover) {\r\n      &:hover {\r\n        background-color: var(--white-550);\r\n      }\r\n    }\r\n  }\r\n\r\n  &--is-active {\r\n    @include active;\r\n  }\r\n\r\n  &:last-child {\r\n    border: none;\r\n  }\r\n\r\n  @media (max-width: 1200px) {\r\n    background: #FFFFFF;\r\n    padding: 8px;\r\n    border-radius: 12px;\r\n    box-shadow: 0px 5px 9px 0px #0000000D;\r\n    border: none;\r\n    position: relative;\r\n\r\n    .title {\r\n      color: var(--text-color);\r\n      font-size: var(--fz-lg);\r\n      line-height: var(--lh-lg);\r\n    }\r\n\r\n    .txt,\r\n    .time {\r\n      color: #54575C;\r\n      font-size: var(--fz-sm);\r\n    }\r\n\r\n    .imgWrap {\r\n      position: initial;\r\n    }\r\n  }\r\n}\r\n\r\n.ellipsis-container {\r\n  display: flex;\r\n  gap: 4px;\r\n  overflow: hidden;\r\n  :global {\r\n    .shortened-text {\r\n      max-height: 13px;\r\n      width: calc(100% - 20px);\r\n    }\r\n  }\r\n\r\n  span {\r\n    width: max-content;\r\n  }\r\n}\r\n\r\n.imgWrap {\r\n  position: relative;\r\n  margin-right: 8px;\r\n}\r\n\r\n.avatar {\r\n  &--is-empty {\r\n    border: 1px solid transparent;\r\n    transition: var(--transition);\r\n  }\r\n}\r\n\r\n.count {\r\n  position: absolute;\r\n  top: -4px;\r\n  right: -4px;\r\n}\r\n\r\n.content {\r\n  width: calc(100% - 48px);\r\n}\r\n\r\n.title,\r\n.txt,\r\n.time {\r\n  transition: var(--transition);\r\n}\r\n\r\n.title {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: baseline;\r\n  margin-bottom: 1px;\r\n}\r\n\r\n.name,\r\n.txt {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.time {\r\n  font-size: var(--fz-xs);\r\n  line-height: var(--lh-xs);\r\n  color: #7A808B;\r\n  margin-left: 20px;\r\n}\r\n\r\n.txt {\r\n  color: #7A808B;\r\n  font-size: 10px;\r\n  line-height: 12px;\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n  text-overflow: ellipsis;\r\n  display: block;\r\n  -webkit-line-clamp: 1;\r\n  display: -webkit-box;\r\n  width: max-content;\r\n}\r\n\r\n.txtImg {\r\n  max-height: 12px;\r\n}\r\n\r\n.txtClip {\r\n  display: flex;\r\n  align-items: center;\r\n  color: #7A808B;\r\n  font-size: 10px;\r\n  line-height: 12px;\r\n\r\n  svg {\r\n    flex-shrink: 0;\r\n    margin-right: 4px;\r\n  }\r\n\r\n  span {\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": `MessagesAsideItem_item__JXIPU`,
	"item--is-active": `MessagesAsideItem_item--is-active__20UZP`,
	"txt": `MessagesAsideItem_txt__n9h6G`,
	"title": `MessagesAsideItem_title__4STYz`,
	"time": `MessagesAsideItem_time__hEzn7`,
	"txtClip": `MessagesAsideItem_txtClip__cho1S`,
	"avatar--is-empty": `MessagesAsideItem_avatar--is-empty__3h7yU`,
	"imgWrap": `MessagesAsideItem_imgWrap__3Vkjf`,
	"ellipsis-container": `MessagesAsideItem_ellipsis-container__OjhLz`,
	"count": `MessagesAsideItem_count__RGvXg`,
	"content": `MessagesAsideItem_content__l4Ky0`,
	"name": `MessagesAsideItem_name__iwUi9`,
	"txtImg": `MessagesAsideItem_txtImg__hCO8C`
};
export default ___CSS_LOADER_EXPORT___;
